var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = (window.theme.moneyFormat) ? window.theme.moneyFormat : "€{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var theme = window.theme || {}

theme.bundle_pubsub = {
  PUB_SUB_EVENTS: {
    variantChange: "variant.change",
    variantSizeOptionChange: "variant.size.option.change",
    stepChange: "step.change",
    stepUpdated: "step.updated",
    regionChange: 'region.change',
    deleteBundleItem: 'delete.bundle.item',
  },

  subscribers: {},

  subscribe: (eventName, callback) => {
    if (theme.bundle_pubsub.subscribers[eventName] === undefined) {
      theme.bundle_pubsub.subscribers[eventName] = [];
    }

    theme.bundle_pubsub.subscribers[eventName] = [...theme.bundle_pubsub.subscribers[eventName], callback];

    return function unsubscribe() {
      theme.bundle_pubsub.subscribers[eventName] = theme.bundle_pubsub.subscribers[eventName].filter((cb) => {
        return cb !== callback
      });
    }
  },

  publish: (eventName, data) => {
    if (theme.bundle_pubsub.subscribers[eventName]) {
      theme.bundle_pubsub.subscribers[eventName].forEach((callback) => {
        callback(data);
      })
    }
  }
};

class ProductBundle extends HTMLElement {
  abortController;
  total = 0;

  constructor() {
    super();
  }

  get steps() {
    return [...this.querySelectorAll("[data-bundle-step]")];
  }

  get constants() {
    return window.theme.bundle_constants || {
      'color': "Color",
      'select_color': "Select Color",
      'size': "Size",
      'select_size': "Select Size",
      'qty': "Qty",
      "price": "Price",
      "edit": "Edit",
      "delete": "Delete",
      "saved": "You have saved:"
    }
  }

  get dynamicSteps() {
    return this.steps.filter(step => {
      const state = step.getAttribute("data-state");

      if (state && !["review", "extras"].includes(state)) {
        return true
      } else {
        return false
      }
    })
  }

  get states() {
    return this.steps.map(item => item.dataset.state);
  }

  get currentState() {
    return this.getAttribute("aria-live")
  }

  get currentStep() {
    return this.steps.filter(item => item.dataset.state === this.currentState)[0];
  }

  get stepExtras () {
    return this.querySelector('[data-bundle-step][data-state="extras"]');
  }

  get stepReview() {
    return this.querySelector('[data-bundle-step][data-state="review"]');
  }

  connectedCallback() {
    this.abortController = new AbortController();
    this.form = this.querySelector("form");

    if (!this.form) {
      return void 0;
    }

    if (this.states[0]) {
      this.setAttribute("aria-live", this.states[0]);
    }

    this.init();
    this.isBusyAria(false, "loaded")
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  init() {
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.variantChange, this.handleOptions.bind(this))
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.variantChange, this.handleMainMedia.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepChange, this.handleMainMedia.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepChange, this.handleFormInputs.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepChange, this.handleReview.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.variantSizeOptionChange, this.handlePrice.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepUpdated, this.handlePrice.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepUpdated, this.handleReview.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.stepUpdated, this.handleFormInputs.bind(this));
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.deleteBundleItem, this.handleDelete.bind(this));

    this.steps.forEach(step => {
      step.querySelector("legend")?.addEventListener("click", this.handleTargetStep.bind(this));
    });
    this.querySelector('[data-bundle-action="extras"]')?.addEventListener("click", this.handleExtras.bind(this));
    this.querySelector('[data-bundle-action="skip"]')?.addEventListener("click", this.handleSkipExtras.bind(this));

    this.bindAccordion();
    this.bindSwatch();
    this.bindExtras();
    this.bindReview();
    this.steps.forEach(step => {
      const state = step.getAttribute("data-state");
      const action = step.querySelector("[data-bundle-action]");

      if (state && !["review", "extras"].includes(state)) {
        this.bindStep(step);

        if (action) {
          action.addEventListener("click", this.handleStep.bind(this))
        }
      }
    })
    
    // this.gallery();
  }

  bindAccordion() {
    const accordionItems = this.querySelectorAll(".bundle-steps li");

    accordionItems.forEach(element => {
      const content = element.querySelector(".bundle-accordion__content");
      content?.style.setProperty("--max-height", `9999px`)
      // content?.style.setProperty("--max-height", `${content.scrollHeight + 40}px`)
    });
  }

  bindSwatch() {
    const swatches = this.querySelectorAll(".bundle-color-swatch");

    swatches.forEach(element => {
      const btn = element.querySelector("li:last-child button");
      btn?.addEventListener("click", (e) => {
        e.preventDefault();
        const span = btn.querySelector("span");

        if (span) {
          if (element.classList.contains("open")) {
            element.classList.remove("open");
            span.textContent = "More";
          } else {
            element.classList.add("open");
            span.textContent = "Less";
          }
        }
      })
    })
  }

  bindStep(step) {
    if (!step) {
      return void 0;
    }

    const variants = step.querySelectorAll("[data-variant]");
    const resetVariant = step.querySelectorAll("[data-variant-reset]");
    const extras = step.querySelectorAll("[data-extra]");
    const extrasContainer = step.querySelector("[data-extra-container]");
    const showExtras = step.querySelector("[data-extra-add]")
    const hideExtras = step.querySelectorAll('[data-extra-hide]');
    const resetExtras = step.querySelectorAll('[data-extra-reset]');
    const tabsContainer = step.querySelector("[data-tabs]");
    const tabsPanelsContainer = step.querySelector("[data-tabs-panels]");
    const extrasTabsCon = extrasContainer?.querySelector("[data-tabs]");
    const extrasPanelsContainer = extrasContainer?.querySelector("[data-tabs-panels]");

    variants.forEach((variant, index) => {
      const colors = variant.querySelector('[data-variant-color]');
      const sizeSelect = variant.querySelector('[data-variant-size] select');
      const quantityInput = variant.querySelector("[data-variant-quantity]");

      if (colors) {
        colors.addEventListener("click", this.handleVariantChange.bind(this));
      }

      if (sizeSelect) {
        sizeSelect.addEventListener("change", this.handleSizeOptionChange.bind(this));
        if (index === 0) {
          sizeSelect.getElementsByTagName("option")[1].selected = true;
          sizeSelect.dispatchEvent(new Event("change"));
        }
      }

      if (quantityInput) {
        quantityInput.addEventListener("change", this.handleStepUpdated.bind(this));
      }
    });

    if (resetVariant.length) {
      resetVariant.forEach(el => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          const variant = e.target.closest("[data-variant]");
          this.reset(variant);
        })
      })
    }

    if (showExtras && extras.length) {
      showExtras.addEventListener("click", (e) => {
        e.preventDefault();

        showExtras.style.display = "none";
        extrasContainer.style.display = "block";
      })
    }

    if (hideExtras.length && extras.length) {
      hideExtras.forEach(el => {
        el.addEventListener("click", (e) => {
          e.preventDefault();

          showExtras.removeAttribute("style");
          extrasContainer.style.display = "none";
          extras.forEach(element => {
            this.reset(element);
            // element.style.display = "none";
          });
        })
      })
    }

    if (resetExtras.length && extras.length) {
      resetExtras.forEach(el => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          const variant = e.target.closest("[data-variant]");
          this.reset(variant);
        })
      })
    }

    if (tabsContainer && tabsPanelsContainer) {
      const panels = tabsPanelsContainer.querySelectorAll("[data-variant]");
      const tabs = tabsContainer.querySelectorAll("[data-tab]")

      tabsContainer.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const target = e.target

        if (target.tagName !== "BUTTON") {
          return void 0;
        }

        tabs.forEach(el => {
          const tab = target.getAttribute("data-tab");
          if (el.getAttribute("data-tab") === tab) {
            el.classList.add("active");

            panels.forEach(variant => {
              if (variant.getAttribute("data-variant") === tab) {
                const color = variant.querySelector("[data-variant-color]");
                const quantity = variant.querySelector("[data-variant-quantity] input");

                variant.classList.add("active");
                if (color && this.currentState !== "extras") {
                  color.querySelector("a").click();
                }

                if (quantity && this.currentState !== "extras") {
                  quantity.value = 1
                }
              } else {
                variant.classList.remove("active");
                this.reset(variant)
              }
            })

          } else {
            el.classList.remove("active");
          }
        })
        
      })
    }

    if (extrasTabsCon && extrasPanelsContainer) {
      const panels = extrasPanelsContainer.querySelectorAll("[data-variant]");
      const tabs = extrasTabsCon.querySelectorAll("[data-tab]")

      extrasTabsCon.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const target = e.target

        if (target.tagName !== "BUTTON") {
          return void 0;
        }

        tabs.forEach(el => {
          const tab = target.getAttribute("data-tab");
          if (el.getAttribute("data-tab") === tab) {
            el.classList.add("active");

            panels.forEach(variant => {
              if (variant.getAttribute("data-variant") === tab) {
                const color = variant.querySelector("[data-variant-color]");
                const quantity = variant.querySelector("[data-variant-quantity] input");

                variant.classList.add("active");
                // if (color) {
                //   color.querySelector("a").click();
                // }

                // if (quantity) {
                //   quantity.value = 1
                // }
              } else {
                variant.classList.remove("active");
                this.reset(variant)
              }
            })

          } else {
            el.classList.remove("active");
          }
        })
        
      })
    }
  }

  getValuesOfStep(step) {
    if (!step) {
      return void 0;
    }

    const state = step.getAttribute("data-state");
    const stepVariants = step.querySelectorAll("[data-variant]");
    const stepValues = [];

    stepVariants.forEach(element => {
      const fieldColor = element.querySelector("[data-variant-color] a.is-selected");
      const fieldSize = element.querySelector("[data-variant-size]");
      const fieldQuantity = element.querySelector("[data-variant-quantity] input");
      const fieldSelect = fieldSize?.querySelectorAll("select") ?? [];
      const { variant } = this.getValues(fieldSelect, element);
      const errors = [];

      if (!fieldColor) {
        errors.push({
          message: "Color is not selected"
        })
      }

      if (!variant) {
        errors.push({
          message: "Size is not selected"
        })
      }

      if (!fieldQuantity || fieldQuantity?.value === "0") {
        errors.push({
          message: "Quantity is not selected"
        })
      }

      if (errors.length) {
        return void 0;
      }

      stepValues.push({
        state: state,
        title: variant.name.replace(` - ${variant.title}`, ""),
        image: element.getAttribute("data-main-image"),
        variant: variant,
        color: fieldColor?.textContent,
        size: variant?.option1,
        quantity: fieldQuantity?.value,
      })
    })
    
    return stepValues.filter(item => item !== undefined);
  }

  getValuesOfExtras() {
    const step = this.stepExtras;
    if (!step) {
      return void 0;
    }

    const steps = step.querySelectorAll("[data-bundle-extra-step]")
    let extras = [];
    steps.forEach(s => {
      const values = this.getValuesOfStep(s);

      if (values && values.length) {
        extras = extras.concat(values);
      }
    })

    return extras;
  }

  handleStep(e) {
    const step = e.target.closest("[data-bundle-step]");

    if (!step) {
      return void 0;
    }

    const variants = step.querySelectorAll("[data-variant]");
    let isValid = false;

    variants.forEach(element => {
      const validation = this.validateGroup(element);

      if (validation.errors.length) {
        if (validation.errors.length < 3) {
          isValid = false
          validation.errors.forEach(item => {
            const field = element.querySelector(`[data-variant-${item.field}]`);

            if (field) {
              field.setAttribute("aria-invalid", "true")
            }
          })
        }
      } else {
        isValid = true
      }
    })

    if (!isValid) {
      step.setAttribute("aria-checked", "false");
      return void 0;
    }

    step.setAttribute("aria-checked", "true");
    this.handleNextStep(e);
  }

  bindExtras() {
    const step = this.stepExtras;
    if (!step) {
      return void 0;
    }
    const groups = step.querySelector(".bundle-variant-groups");
    const cta = step.querySelector(".bundle-variant-group-cta");
    if (!cta) {
      return void 0;
    }

    const ctaAction = cta.querySelectorAll('[data-bundle-extra-action]');
    const steps = step.querySelectorAll("[data-bundle-extra-step]");
    const hideExtra = step.querySelectorAll("[data-extra-hide]");
    const resetExtra = step.querySelectorAll("[data-extra-reset]");

    steps.forEach(s => {
      this.bindStep(s);
      this.reset(s);
    })

    ctaAction.forEach(s => {
      s.addEventListener("click", (e) => {
        e.preventDefault();
        const t = e.currentTarget;

        if (t instanceof Element) {
          const cta = t.closest(".bundle-variant-group-cta");
          const busy = t.getAttribute("aria-busy");
          const action = t.getAttribute("data-bundle-extra-action");
          const extraStep = groups?.querySelector(`[data-bundle-extra-step="${action}"]`);

          if (extraStep && cta) {
            if (busy === "true") {
              t.setAttribute("aria-busy", "false");
              extraStep.setAttribute("aria-expanded", "false");
              this.reset(extraStep);
            } else {
              t.setAttribute("aria-busy", "true");
              extraStep.setAttribute("aria-expanded", "true");
            }
            cta.dispatchEvent(new Event("change"));
          }
        }
      })
    })

    cta.addEventListener("change", (e) => {
      e.stopPropagation();

      let ariaLive = "false";
      ctaAction.forEach(s => {
        const b = s.getAttribute("aria-busy");
        if (b === "true") {
          ariaLive = "true";
        }
      })

      cta.setAttribute("aria-live", ariaLive);
    })

    hideExtra.forEach(action => {
      action.addEventListener("click", (e) => {
        const target = e.target;

        if (target instanceof HTMLElement) {
          const step = target.closest('[data-bundle-extra-step]');
          const variants = step?.querySelectorAll("[data-variant]");
          
          ctaAction.forEach(s => {
            if (s.getAttribute("data-bundle-extra-action") === step?.getAttribute("data-bundle-extra-step")) {
              step.removeAttribute("aria-checked");
              s.setAttribute("aria-busy", "false");
            }
          })
          step?.setAttribute("aria-expanded", "false");
          cta.dispatchEvent(new Event("change"));
          variants?.forEach(v => {
            this.reset(v);
          })
        }
      })
    })

    resetExtra.forEach(item => {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        const target = e.target;
        if (target instanceof HTMLElement) {
          const variant = target?.closest("[data-variant]");
          this.reset(variant);
        }
      })
    })
  }

  bindReview() {
    const step = this.stepReview;
    if (!step) {
      return void 0;
    }

    const finalProduct = this.querySelector("[data-final-product]");
    const additionalActions = step.querySelectorAll("[data-bundle-additional-action]");

    if (!finalProduct) {
      return void 0;
    }

    finalProduct.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const target = e.target;
      let step;

      if (target instanceof Element) {
        step = target.getAttribute("data-state");

        if (step?.includes("extra") || step?.includes("another")) {
          step = "extras"
        }

        if (target.getAttribute("data-bundle-edit")) {
          this.handleStepChange(step);
        }
        
        if (target.getAttribute("data-bundle-delete")) {
          theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.deleteBundleItem, {
            data: {
              state: target.getAttribute("data-state"),
              step: step,
              variantId: target.getAttribute("data-bundle-delete")
            }
          });
        }
      }
    })

    additionalActions.forEach(action => {
      action.addEventListener("click", () => {
        this.handleStepChange("extras");
      })
    })
  }

  reset(node) {
    const colorGroup = node.querySelector("[data-variant-color]");
    const sizeGroup = node.querySelector("[data-variant-size]");
    const fieldQuantity = node.querySelector('input[name="quantity"]');

    node.removeAttribute("aria-checked");

    if (colorGroup) {
      colorGroup.querySelector(".is-selected")?.classList.remove("is-selected");
      colorGroup.querySelector(".bundle-variant-group__header span").innerHTML = this.constants.select_color;
      colorGroup.removeAttribute("aria-invalid");
    }

    if (sizeGroup) {
      sizeGroup.querySelector(".bundle-variant-group__header span").innerHTML = this.constants.select_size;
      sizeGroup.querySelector("[data-bundle-variant-options] select option").selected = true;
      sizeGroup.removeAttribute("aria-invalid");
    }

    if (fieldQuantity) {
      const min = fieldQuantity.getAttribute("min");
      fieldQuantity.value = min;
      fieldQuantity.parentElement?.removeAttribute("aria-invalid");
    }

    this.handleStepUpdated();

    return node;
  }

  isBusyAria(busy = true, debug = "") {
    this.setAttribute("aria-busy", `${busy}`);
  }

  getSelectedVariant(productInfoNode) {
    const selectedVariant = productInfoNode.querySelector('[data-selected-variant]')?.textContent;
    return !!selectedVariant ? JSON.parse(selectedVariant) : null;
  }

  getVariant(nodes, needle) {
    return nodes.filter(item => item.title.includes(needle))[0];
  }

  getVariants(productInfoNode) {
    const variants = productInfoNode.querySelector('[data-variant-json]')?.textContent;
    return !!variants ? JSON.parse(variants) : null;
  }

  renderProductInfo({ requestUrl, target, callback }) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        this.pendingRequestUrl = null;
        if (callback !== undefined) {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          callback({
            parsedHTML: parsedHTML,
            target: target
          });
        }
      })
      .then(() => {
        const group = target.closest("[data-variant]");
        const colorgroup = group.querySelector("[data-variant-color]");
        
        if (colorgroup) {
          colorgroup.querySelector(".bundle-variant-group__header span").innerHTML = target.getAttribute("title")
        }

        target.classList.add("is-selected");

        this.isBusyAria(false);
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });
  }

  handleNextStep(e) {
    let nextStep;
    // const current = e.currentTarget.getAttribute("data-bundle-action");

    const index = this.states.findIndex((i) => i === this.currentState);
    nextStep = this.states[index + 1];

    this.handleStepChange(nextStep);
  }

  handleConfirm(e) {
    e.preventDefault();
    e.stopPropagation();

    let values = [];
    const index = this.states.findIndex((i) => i === e.target.getAttribute("data-bundle-action"));
    const step = this.steps[index];
    const size = step.querySelector("[data-variant-size]");
    const options = size?.querySelectorAll("select") ?? [];
    const getVariants = (productInfoNode) => {
      const variants = productInfoNode.querySelector('[data-product-variants]')?.textContent;
      return !!variants ? JSON.parse(variants) : null;
    };
    const getVariant = (option1, option2) => {
      const variants = getVariants(this.currentStep);
      const selectedVariant = variants.filter(item => {
        return (item.option1 === option1.value && item.option2 === option2.value)
      });

      return !!selectedVariant.length
    }

    options.forEach(select => {
      values.push({
        position: select.getAttribute("data-position"),
        value: select.options[select.selectedIndex].value
      })
    });

    if (values[0].value === "") {
      step.setAttribute("aria-checked", "false");
    } else {
      const variant = getVariant(values[0], values[1]);

      if (!variant) {
        step.setAttribute("aria-checked", "false");

        return void 0;
      }

      step.setAttribute("aria-checked", "true");
      // this.handleStepChange(this.states[index + 1]);
    }
  }

  validateGroup(group) {
    const fieldColor = group.querySelector("[data-variant-color] a.is-selected");
    const fieldSize = group.querySelector("[data-variant-size]");
    const fieldQuantity = group.querySelector("[data-variant-quantity] input");
    const fieldSelect = fieldSize?.querySelectorAll("select") ?? [];
    const { variant } = this.getValues(fieldSelect, group);
    const errors = [];

    if (!fieldColor) {
      errors.push({
        field: "color",
        message: "Color is not selected"
      })
    }

    if (!variant) {
      errors.push({
        field: "size",
        message: "Size is not selected"
      })
    }

    if (!fieldQuantity || fieldQuantity?.value === "0") {
      errors.push({
        field: "quantity",
        message: "Quantity is not selected"
      })
    }

    return {
      variant: group.getAttribute("data-variant"),
      errors: errors
    }
  }

  validateStep(step) {
    let values = [];
    const stepVariants = step.querySelectorAll("[data-variant]");
    const stepValues = [];

    stepVariants.forEach(element => {
      const fieldColor = element.querySelector("[data-variant-color] a.is-selected");
      const fieldSize = element.querySelector("[data-variant-size]");
      const fieldQuantity = element.querySelector("[data-variant-quantity] input");
      const fieldSelect = fieldSize?.querySelectorAll("select") ?? [];
      const { variant } = this.getValues(fieldSelect, element);
      const errors = [];

      if (!fieldColor) {
        errors.push({
          field: "color",
          message: "Color is not selected"
        })
      }

      if (!variant) {
        errors.push({
          field: "size",
          message: "Size is not selected"
        })
      }

      if (!fieldQuantity || fieldQuantity?.value === "0") {
        errors.push({
          field: "quantity",
          message: "Quantity is not selected"
        })
      }

      stepValues.push({
        variant: element.getAttribute("data-variant"),
        errors: errors
      })
    });

    return stepValues;
  }

  handleStepUpdated() {
    theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.stepUpdated, {});
  }

  handleStepChange(step) {
    const previous = this.getAttribute("aria-live");

    if (!step) {
      return void 0;
    }

    if (step === this.currentState) {
      return void 0;
    }

    this.isBusyAria();
    this.setAttribute("aria-live", step);
    const filteredStep = this.steps.filter(s => s.getAttribute("data-state") === step)
    const target = (filteredStep.length) ? filteredStep[0].querySelector("a.is-selected") : undefined;
    theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.stepChange, {
      data: {
        previous: previous,
        state: step,
        target: target
      }
    });

    // window.scrollTo({
    //   top: this.getBoundingClientRect().top,
    //   left: 0,
    //   behavior: 'smooth'
    // });

    this.steps.forEach(s => {
      s.setAttribute("aria-expanded", "false");

      if (s instanceof HTMLElement && s.dataset.state === this.currentState) {
        s.setAttribute("aria-expanded", "true");
      }
    });

    this.isBusyAria(false);
  }

  handleStepVariantChange(e) {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.tagName !== "A") {
      return void 0;
    }

    this.isBusyAria();
    const link = e.target;
    const group = link.closest("[data-state]");

    if (group) {
      group.querySelectorAll("a.is-selected").forEach((item) => {
        item.classList.remove("is-selected");
      })

      group.querySelectorAll("[data-variant-size] select").forEach((select) => {
        select.querySelector("option").selected = true;
        // select.dispatchEvent(new Event("change"));
      })
    }

    this.renderProductInfo({
      requestUrl: link.href,
      target: link,
      callback: this.handleProductUpdate()
    })
  }

  handleVariantChange(e) {
    e.preventDefault();
    e.stopPropagation();

    this.isBusyAria();
    if (e.target.tagName !== "A") {
      this.isBusyAria(false);
      return void 0;
    }

    const link = e.target;
    const group = link.closest("[data-variant-color]");

    if (group) {
      group.querySelectorAll("a.is-selected").forEach((item) => {
        item.classList.remove("is-selected");
      })

      group.removeAttribute("aria-invalid");
    }

    this.renderProductInfo({
      requestUrl: link.href,
      target: link,
      callback: this.handleProductUpdate()
    })
  }

  handleSizeOptionChange(e) {
    e.preventDefault();
    e.stopPropagation();

    const target = e.target;

    if (target.tagName !== "SELECT") {
      return void 0;
    }

    const group = target.closest("[data-variant-size]");

    if (group) {
      group.querySelector(".bundle-variant-group__header span").innerHTML = target.selectedOptions[0].getAttribute("data-original-title")
      group.removeAttribute("aria-invalid");
    }

    theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.variantSizeOptionChange, {
      data: {
        target: target
      }
    });
  }

  handleOptions({ data: { parsedHTML, target, variants } }) {
    const group = target.closest(".bundle-variant-group");
    const sizegroup = group.querySelector("[data-variant-size]");
    const options = group.querySelector('select[data-position="option1"]');
    const options2 = group.querySelector('select[data-position="option2"]');
    const selectedValue = options.value;
    const getSelect = (items, v, option1 = true) => {
      const div = document.createElement("div");
      const select = document.createElement("select");
      const optionSelect = document.createElement("option");
      const getVariantByTitle = (value) => {
        return v.filter(i => i.title.includes(value))[0];
      }

      if (option1) {
        optionSelect.value = "";
        optionSelect.innerHTML = this.constants.select_size;
        select.appendChild(optionSelect);
      }
      
      items.forEach((element, index) => {
        const option = document.createElement("option");
        // const variant = getVariantByTitle(element.value);
        option.value = element.value;
        option.innerHTML = element.innerHTML;
        if (option.value === selectedValue) {
          option.setAttribute("selected", "true");
        }

        // option.setAttribute("data-price", variant.price);
        option.setAttribute("data-original-title", element.value);
        option.setAttribute('data-filter-region', element.dataset.region);
        option.setAttribute('data-alternative-title-us', element.getAttribute("data-alternative-title-us"));
        option.setAttribute('data-available', element.getAttribute("data-available"));
        select.appendChild(option);
      });

      select.setAttribute("name", "id");
      div.classList.add("select-wrapper");
      div.appendChild(select);

      return select;
    }
    const getOption = (wrapper, i) => {
      const element = wrapper.querySelector(`[data-index="option${i}"]`);
      const name = wrapper.querySelector(`[data-index="option${i}"] select`)?.getAttribute("name");

      return {
        name: name,
        element: element
      }
    }

    const parsedOptions = parsedHTML.querySelector('#option1');
    const parsedOptions2 = parsedHTML.querySelector('#option2');
    const select = getSelect(parsedOptions.querySelectorAll("option"), variants);
    const select2 = getSelect(parsedOptions2.querySelectorAll("option"), variants, false);

    if (options && select) {
      options.innerHTML = select.innerHTML;
    }

    if (sizegroup) {
      const selected = select.options[select.selectedIndex].value;
      if (selected) {
        sizegroup.querySelector(".bundle-variant-group__header span").innerHTML = selected
      } else {
        sizegroup.querySelector(".bundle-variant-group__header span").innerHTML = this.constants.select_size
      }
      
    }

    if (options2 && select2) {
      options2.innerHTML = select2.innerHTML
    }

    const selectedRegion = this.currentStep.querySelector("[data-bundle-options-filter] input:checked");
    theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.regionChange, {
      data: {
        event: undefined,
        target: undefined,
        selectedOptionValue: selectedRegion ? selectedRegion.value : "EU"
      }
    });
  }

  handleOptionChange({ data: { selectedOptionValue } }) {
    // const options = this.getOptionsByValue(selectedOptionValue)
  }

  handleProductUpdate() {
    return ({ parsedHTML, target }) => {
      const variant = this.getSelectedVariant(parsedHTML);
      const variantsJson = this.getVariants(parsedHTML);
      const variantEl = target.closest("[data-variant]");
      const source = parsedHTML.querySelector("[data-variant-json]");
      const destination = variantEl.querySelector("[data-product-variants]");

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }

      this.handleMedia({
        data: {
          target: target,
          parsedHTML: parsedHTML
        }
      });

      theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.variantChange, {
        data: {
          parsedHTML: parsedHTML,
          target: target,
          variants: variantsJson,
          variant_selected: variant
        }
      });
    }
  }

  handlePrice() {
    const discount = parseInt(this.getAttribute("data-discount") ?? "0");
    const priceField = this.querySelector("[data-selected-bundle-price]");
    const finalPrice = this.querySelector("[data-final-product-price]");
    const extras = this.getValuesOfExtras();

    if (!priceField || !finalPrice) {
      return void 0;
    }

    let price = 0;
    let discountedPrice = 0;
    let discountMoney = 0;

    this.dynamicSteps.forEach(step => {
      const values = this.getValuesOfStep(step);
      const filteredValues = values?.filter(item => !item.hasErrors)

      if (filteredValues && filteredValues.length) {
        filteredValues.forEach(v => {
          price = price + v.variant.price * parseInt(v.quantity)
        })
      }
    })

    if (extras) {
      extras.forEach(e => {
        price = price + e.variant.price * parseInt(e.quantity)
      })
    }

    discountedPrice = price * (1 - discount / 100);
    discountMoney = price * discount / 100;
    
    priceField.innerHTML = `<s>${Shopify.formatMoney(price)}</s><span>${Shopify.formatMoney(discountedPrice)}</span>`;
    finalPrice.innerHTML = `<div class="bundle-final__discount-sum"><span>${this.constants.saved} ${Shopify.formatMoney(discountMoney)}</span></div><div class="bundle-final__sum"><s>${Shopify.formatMoney(price)}</s><span>${Shopify.formatMoney(discountedPrice)}</span></div>`
  }

  gallery() {
    const breakpoint = window.matchMedia('(min-width: 768px)');
    let productSlider;
    const breakpointChecker = function () {
      if (breakpoint.matches === true) {
        if (productSlider !== undefined) productSlider.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = function () {
      if (productSlider !== undefined) productSlider.destroy(true, true);
      if (typeof Swiper !== undefined) {
        const container = document.querySelector(".product__media-container.below-mobile");

        productSlider = new Swiper(container, {
          wrapperClass: "product__media",
          slideClass: "image",
          slidesPerView: 'auto',
          centeredSlides: true,
          a11y: true,
          keyboardControl: true,
          grabCursor: true,
          spaceBetween: 10,
        });
      }
    };

    breakpointChecker();
    breakpoint.addListener(breakpointChecker);
  }

  handleMainMedia({ data: { state, target } }) {
    const destinationList = document.querySelectorAll('.product__media-container');
    let container;

    if (state === "extras" || state === "review") {
      return void 0;
    }

    if (target) {
      container = target.closest("[data-main-image]")
    } else {
      container = this.currentStep.querySelector("[data-main-image]")
    }

    const mainImage = container.getAttribute("data-main-image");
    // const images = container.getAttribute("data-images").split(",");
    
    destinationList.forEach(destination => {
      const img = destination.querySelector(".product__media img");

      // if (img) {
        // const imagesContent = [];
        // images.forEach(image => {
        //   imagesContent.push(`<div class="image"><img src="${image}" /></div>`)
        // })

        // img.innerHTML = imagesContent.join("");
      // }

      if (img && mainImage) {
        img.src = mainImage;
      }
    });

    // this.gallery();
  }

  handleMedia({ data: { parsedHTML, target } }) {
    const source = parsedHTML.querySelectorAll(".product__media-container.above-mobile .product__media-item img")
    const getImage = (arrayItems) => {
      return arrayItems[0];
    }
    const getGallery = (arrayItems) => {
      const gallery = [];

      arrayItems.forEach(img => {
        const src = img.src.replace("&width=320", "");
        gallery.push(src)
      })

      return gallery;
    }

    if (source && source.length) {
      const image = getImage(source);
      const gallery = getGallery(source);

      const img = image.src.replace("&width=320", "");
      const variant = target.closest("[data-variant]");

      variant.setAttribute("data-main-image", img)
      variant.setAttribute("data-images", gallery.join(","))
    }
  }

  getValues(options, node = this.currentStep) {
    let values = [];
    
    const getVariant = (option1, option2) => {
      const variants = this.getVariantsOfStep(node);
      const selectedVariant = variants.filter(item => {
        return (item.option1 === option1.value && item.option2 === option2.value)
      });

      return selectedVariant[0]
    }

    options.forEach(select => {
      if (select.options[select.selectedIndex].value) {
        values.push({
          position: select.getAttribute("data-position"),
          value: select.options[select.selectedIndex].value
        })
      }
    });

    return {
      values: values,
      variant: getVariant(values[0], values[1])
    };
  }

  handleTargetStep(e) {
    const targetStep = e.target.closest("[data-bundle-step]");

    if (targetStep.getAttribute("aria-checked")) {
      this.handleStepChange(targetStep.dataset.state)
    }
  }

  getVariantsOfStep(productInfoNode) {
    const variants = productInfoNode.querySelector('[data-product-variants]')?.textContent;
    return !!variants ? JSON.parse(variants) : null;
  }

  handleExtras() {
    const step = this.stepExtras;
    if (!step) {
      return void 0;
    }

    const variants = step.querySelectorAll("[data-variant]");
    let isValid = false;

    variants.forEach(element => {
      const validation = this.validateGroup(element);

      if (validation.errors.length) {
        if (validation.errors.length < 3) {
          isValid = false
          validation.errors.forEach(item => {
            const field = element.querySelector(`[data-variant-${item.field}]`);

            if (field) {
              field.setAttribute("aria-invalid", "true")
            }
          })
        }
      } else {
        isValid = true
      }
    })

    if (!isValid) {
      step.setAttribute("aria-checked", "false");
      return void 0;
    }

    step.setAttribute("aria-checked", "true");
    this.handleStepChange("review");
  }

  handleSkipExtras() {
    const step = this.stepExtras;
    if (!step) {
      return void 0;
    }

    const cta = step.querySelector(".bundle-variant-group-cta");
    if (!cta) {
      return void 0;
    }

    const steps = step.querySelectorAll("[data-bundle-extra-step]")
    const stepsActions = cta.querySelectorAll('[data-bundle-extra-action]');

    steps.forEach(s => {
      const variants = s.querySelectorAll("[data-variant]");

      s.setAttribute("aria-expanded", "false");
      variants.forEach(v => {
        this.reset(v)
      });
    })

    stepsActions.forEach(a => {
      a.removeAttribute("aria-busy");
    })

    cta.removeAttribute("aria-live");
    step.setAttribute("aria-checked", "true");
    this.handleStepChange("review");
  }

  handleFormInputs() {
    const inputs = [];
    const totals = [];
    const form = this.form;
    const title = this.getAttribute("data-product-title");
    const randomString = Math.random().toString(36).slice(2, 8);
    const bundleCode = this.getAttribute('data-code') || "";
    const extras = this.getValuesOfExtras();

    if (!form || !title) {
      return void 0;
    }

    // Update inputs
    const printedInputs = form.querySelectorAll(".product-bundle__input");
    printedInputs.forEach(item => item.remove());

    this.dynamicSteps.forEach(step => {
      const values = this.getValuesOfStep(step);

      if (values && values.length) {
        values.forEach(v => {
          inputs.push({
            variant: v.variant.id,
            quantity: v.quantity
          })

          totals.push(v.variant.id);
        })
      }
    });

    if (extras && extras.length) {
      extras.forEach(e => {
        inputs.push({
          variant: e.variant.id,
          quantity: e.quantity
        })
      })
    }

    inputs.forEach((data, index) => {
      const product = document.createElement("input");
      const quantity = document.createElement("input");
      const properties = document.createElement("input");
      const discount = document.createElement('input');

      product.setAttribute("name", `items[${index}][id]`);
      product.setAttribute("type", "hidden");
      product.classList.add("product-bundle__input");
      product.setAttribute("value", data.variant);

      quantity.setAttribute("name", `items[${index}][quantity]`);
      quantity.setAttribute("type", "hidden");
      quantity.classList.add("product-bundle__input");
      quantity.setAttribute("value", data.quantity);

      properties.setAttribute("name", `items[${index}]properties[Part of a bundle]`);
      properties.setAttribute("type", "hidden");
      properties.classList.add("product-bundle__input");
      properties.setAttribute("value", `${title} (${randomString})`);

      // Add discount code
      discount.setAttribute('name', `items[${index}]properties[_bundle-discount]`);
      discount.setAttribute('type', 'hidden');
      discount.classList.add("product-bundle__input");
      discount.setAttribute('value', bundleCode);

      form.appendChild(product);
      form.appendChild(quantity);
      form.appendChild(properties);
      form.appendChild(discount);
    });
    
    if (totals.length) {
      const inputTotals = document.createElement("input");
      inputTotals.setAttribute("name", `ids`);
      inputTotals.setAttribute("type", "hidden");
      inputTotals.classList.add("product-bundle__input");
      inputTotals.setAttribute("value", totals.join(","));
      form.appendChild(inputTotals);
    }
  }

  handleDelete({ data: { variantId, state, step } }) {
    const filteredStep = this.steps.filter(s => s.getAttribute("data-state") === step)[0];
    const variants = filteredStep.querySelectorAll("[data-variant]");

    variants.forEach(variant => {
      const fieldSize = variant.querySelector('[data-variant-size]')
      const options = fieldSize?.querySelectorAll("select") ?? [];
      const stepVariant = this.getValues(options, variant);

      if (stepVariant.variant && stepVariant.variant.id === parseInt(variantId)) {
        this.reset(variant)

        theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.stepUpdated, {
          data: {
            state: state
          }
        })
      }
    })
  }

  handleReview(e) {
    const step = this.stepReview;
    if (!step) {
      return void 0
    }

    const finalProductsField = step.querySelector("[data-final-product]");
    const extras = this.getValuesOfExtras();
    let dataList = [];
    let content = [];

    this.dynamicSteps.forEach(step => {
      const values = this.getValuesOfStep(step);

      if (values && values.length) {
        dataList = dataList.concat(values);
      }
    })

    if (extras && extras.length) {
      dataList = dataList.concat(extras);
    }

    if (dataList.length) {
      dataList.forEach(product => {
        if (product) {
          content = content.concat([
            `<li data-state="${product.state}">`,
            '<div class="bundle-final-product">',
            '<div class="bundle-final-image">',
            '<div class="image">',
            `<img src="${product.image}" alt="">`,
            '</div>',
            '</div>',
            '<div class="bundle-final-wrapper">',
            `<div class="ff-heading fs-heading-5-base">${product.title}</div>`,
            '<div class="bundle-final-content">',
            '<div class="bundle-final-content__options" data-final-product-options="">',
            `<div><strong>${this.constants.color}:</strong><span>${product.color}</span></div><div><strong>${this.constants.size}:</strong><span>${product.size}</span></div><div><strong>${this.constants.qty}:</strong><span>${product.quantity}</span>`,
            '</div></div>',
            '<div class="bundle-final-content__right">',
            `<div class="bundle-final-content__price"><strong>${this.constants.price}:</strong> ${Shopify.formatMoney(product.variant.price * parseFloat(product.quantity))}</div>`,
            '<div class="bundle-final-content__actions">',
            `<button type="button" data-bundle-edit="${product.variant.id}" data-state="${product.state}">${this.constants.edit}</button>`,
            `<button type="button" data-bundle-delete="${product.variant.id}" data-state="${product.state}">${this.constants.delete}</button>`,
            '</div>',
            '</div>',
            '</div>',
            '</div>',
            '</div>',
            '</li>'
          ]);  
        }     
      });
    } else {
      content.push("<li></li>")
    }

    if (finalProductsField && content.length) {
      finalProductsField.innerHTML = content.join("");
    }
  }
}
customElements.define('product-bundle', ProductBundle);

class ProductBundleRegion extends HTMLElement {

  get selectedOptionValue() {
    return this.querySelector('[data-bundle-options-filter] input:checked')?.getAttribute("value");
  }

  get isRegionFilterDisabled() {
    return !!this.getAttribute("data-disable-region");
  }

  get constants() {
    return window.theme.bundle_constants || {
      'color': "Color",
      'select_color': "Select Color",
      'size': "Size",
      'select_size': "Select Size",
      'qty': "Qty",
      "price": "Price",
      "edit": "Edit",
      "delete": "Delete"
    }
  }

  connectedCallback() {
    theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.regionChange, this.handleRegionChange.bind(this))
    // theme.bundle_pubsub.subscribe(theme.bundle_pubsub.PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this))

    if (this.isRegionFilterDisabled) {
      this.querySelector("[data-bundle-options-filter]")?.classList.add("hidden");
    } else {
      this.querySelector("[data-bundle-options-filter]")?.classList.remove("hidden");
    }

    this.querySelector("[data-bundle-options-filter]")?.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);

      theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.regionChange, {
        data: {
          event,
          target,
          selectedOptionValue: this.selectedOptionValue
        }
      });
    });

    theme.bundle_pubsub.publish(theme.bundle_pubsub.PUB_SUB_EVENTS.regionChange, {
      data: {
        event: undefined,
        target: undefined,
        selectedOptionValue: "EU"
      }
    });
  }

  handleRegionChange({ data: { selectedOptionValue } }) {
    const currentFilter = this.querySelector('[data-bundle-options-filter] input:checked')?.getAttribute("value");
    const options = this.querySelectorAll("[data-bundle-variant-options] option");

    if (currentFilter !== selectedOptionValue) {
      this.querySelectorAll("input").forEach(item => {
        if (item.getAttribute("value") === selectedOptionValue) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      })
    }

    // let hasUpdated = false;
    options.forEach(option => {
      const title = option.getAttribute("data-original-title") ?? "";
      const altTitle = option.getAttribute("data-alternative-title-us");
      const filter = option.getAttribute("data-filter-region");
      const price = option.getAttribute("data-price");

      if (option.textContent === this.constants.select_size) {
        return void 0;
      }
      // option.removeAttribute("selected");

      if (!this.isRegionFilterDisabled) {
        if (filter?.includes(selectedOptionValue)) {
          option.removeAttribute("hidden");
          option.removeAttribute("disabled");

          // if (!hasUpdated) {
          //   option.selected = true;
          //   hasUpdated = true;
          // }
        } else {
          option.setAttribute("hidden", "hidden");
          option.setAttribute("disabled", "disabled");
        }
      }

      if (altTitle) {
        if (selectedOptionValue === "US") {
          option.innerHTML = `${altTitle}`;
        } else {
          option.innerHTML = `${title}`
        }
      } else {
        option.innerHTML = `${title}`
      }
    })
  }

  handleVariantChange({ data: { parsedHTML } }) {

  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
}
customElements.define('product-bundle-region', ProductBundleRegion);

class ProductBundleQuantity extends HTMLElement {
  
  constructor() {
    super();

    this.input = this.querySelector("input");
  }

  connectedCallback() {
    const decrement = this.querySelector("[data-variant-quantity-minus]");
    const increment = this.querySelector("[data-variant-quantity-plus]");

    if (increment) {
      increment.addEventListener("click", this.handleAdd.bind(this))
    }

    if (decrement) {
      decrement.addEventListener("click", this.handleSubtract.bind(this))
    }
  }

  handleSubtract() {
    if (!this.input) {
      return void 0;
    }

    let value = parseInt(this.input.value);

    if (value > parseInt(this.input.min)) {
      value--;
      this.input.value = value.toString();
    }

    if (this.getAttribute("aria-invalid") && value > 0) {
      this.removeAttribute("aria-invalid");
    }

    this.dispatchEvent(new Event("change"));
  }

  handleAdd() {
    if (!this.input) {
      return void 0;
    }

    let value = parseInt(this.input.value);
    value++;
    this.input.value = value.toString();

    if (this.getAttribute("aria-invalid") && value > 0) {
      this.removeAttribute("aria-invalid");
    }

    this.dispatchEvent(new Event("change"));
  }
}
customElements.define('product-bundle-quantity', ProductBundleQuantity);